/** 保险分包业务文案 — 中文 */
export default {
  insurance: {
    nav: {
      home: '保险',
      detail: '保险详情',
    },
    common: {
      orderNo: '订单号：{id}',
      total: '合计￥{amount}',
      countUnit: '共{count}份',
      detail: '详情',
      actualPaid: '实付',
      actualRefund: '实退金额',
      estimatedRefundPoints: '另退积点',
      unionPointCount: '{count} 积点',
      priceMultiply: '￥{price} ×{count}',
      applyTime: '申请时间：{time}',
      policyTab: '保单{index}',
      policyNo: '保单编号',
      flightRange: '保障航程',
      insurer: '承保公司',
      insuType: '保险类型',
      policySummary: '{name}：{insuranceName}(保单：{route})',
    },
    tip: {
      invoice: '航班起飞后可在当前页面开保险发票，也可在订单详情页和机票一起开',
    },
    btn: {
      refundHistory: '退订记录',
      applyRefund: '申请退订',
      invoice: '报销凭证',
      invoiceDetail: '发票详情',
      confirmRefund: '确认退订',
    },
    popup: {
      amountDetail: '订单金额明细',
      applyRefund: '申请退订',
      refundHistory: '退订记录',
      invoiceDetail: '发票详情',
    },
    section: {
      coverage: '保障内容',
      detail: '保险详情',
      claim: '理赔方式',
    },
    claim: {
      delay: '请拨打保险详情里的客服电话',
      accident: '请联系承保公司进行理赔',
    },
    toast: {
      refundSuccess: '退订成功',
      cannotRefund: '该机票正在改签中，暂无法退订保险。如需退订，请完成改签或取消改签后重新申请',
      insuringCannotRefund: '投保中，无法退订',
    },
  },
}
